import { memo } from 'react'
import classNames from 'classnames'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { CloseButtonWithCountdown } from '../../../../common/components/CloseButtonWithCountdown'
import { WorkoutCheckInBadgeProps } from '../../OnDemandWorkoutsDetail.d'
import { CheckInBadge } from '../CheckInBadge'
import styles from './WorkoutCheckInBadge.module.scss'

const WorkoutCheckInBadge = ({
  userName,
  checkins,
  totalSeconds,
  secondsRemaining,
  deviceWidth,
  className = '',
  onCloseButtonClick = () => {},
}: WorkoutCheckInBadgeProps) => {
  const isMobile = deviceWidth <= 320
  const highFive = 'High-five'
  const heading = userName ? `${highFive}, ${userName}` : highFive

  return (
    <Card raised className={classNames(styles.card, className)}>
      <div className={styles.container}>
        <CheckInBadge checkins={checkins} />
        <div className={styles.text}>
          <Heading type="h5">{heading}!</Heading>
          <Paragraph size={isMobile ? 'xsmall' : 'small'} weight="book">
            You’ve earned a check-in!
          </Paragraph>
        </div>
      </div>
      <CloseButtonWithCountdown
        totalSeconds={totalSeconds}
        secondsRemaining={secondsRemaining}
        onCloseButtonClick={() => onCloseButtonClick()}
      />
    </Card>
  )
}

export default memo(WorkoutCheckInBadge)
